import type { ListBoxProps } from '@repo/foundations';
import type { InputRule } from 'prosemirror-inputrules';
import type { ParseSpec } from 'prosemirror-markdown';
import type {
	NodeSpec,
	NodeType,
	Node as ProsemirrorNode,
	Schema,
} from 'prosemirror-model';
import type { Command } from 'prosemirror-state';
import type { CommandFactory } from '../lib/Extension';
import Extension from '../lib/Extension';
import type { MarkdownSerializerState } from '../lib/markdown/serializer';

export type NodeOptions = { type: NodeType; schema: Schema };
export type PreselectionWidgetProps = {
	onClose: () => void;
	targetRef: ListBoxProps['targetRef'];
};

export default abstract class Node extends Extension<NodeType> {
	get type() {
		return 'node';
	}

	get schema(): NodeSpec {
		return {};
	}

	get markdownToken(): string {
		return '';
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	inputRules(_options: NodeOptions): InputRule[] {
		return [];
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	keys(_options: NodeOptions): Record<string, Command> {
		return {};
	}

	commands(
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		_options: NodeOptions
	): Record<string, CommandFactory> | CommandFactory {
		return {};
	}

	toMarkdown(state: MarkdownSerializerState, node: ProsemirrorNode): void {
		// eslint-disable-next-line no-console
		console.error('toMarkdown not implemented', state, node);
	}

	parseMarkdown(): ParseSpec | void {
		return undefined;
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	preselectionWidget(_props: PreselectionWidgetProps): React.ReactNode {
		return null;
	}
}
